
import React from 'react';
import './MahutiModal.css';


const MahutiModal = React.forwardRef((props, ref) => {
    const handleClickExist = props.setModalOpen.bind(this);
    const customFN = props.customFN
    const closeModalWhenClickingBg = props.closeModalWhenClickingBg

    return <div className='mahutiModal bg' onClick={() => {handleClickExist(!closeModalWhenClickingBg); customFN && customFN()}} >
            <div onClick={(e) => e.stopPropagation()} className='inline-modal'>
                {props.children}
            </div>
        </div>

});

export default MahutiModal;